export const parseHomeUrl = () =>
  window.SUBDOMAIN && window.SUBDOMAIN !== "/" ? `/${window.SUBDOMAIN}/` : "/"
